import { useQueryClient } from '@tanstack/react-query';
import { Clock, LogOut, RefreshCw } from 'lucide-react';
import { useSession } from '../../lib/session.tsx';
import { Button } from '../ui/button.tsx';

/**
 * What a first sign-in sees until an admin activates the account (TS-956). Checking again
 * re-reads everything (/me, and /flags, which the API refused while they were invited), so
 * once they are activated the app appears without signing in again.
 */
export function PendingActivation() {
  const session = useSession();
  const qc = useQueryClient();
  const { user, organisation } = session.me;
  return (
    <main className="relative flex min-h-dvh items-center justify-center overflow-hidden p-6">
      <div
        className="bg-card border-border shadow-raised relative w-full max-w-md rounded-2xl border p-8 text-center"
        role="status"
        data-testid="pending-activation"
      >
        <span className="bg-state-warning-bg text-state-warning-fg mx-auto grid size-14 place-items-center rounded-2xl">
          <Clock className="size-7" aria-hidden />
        </span>
        <h1 className="mt-5 text-xl font-bold tracking-tight">Waiting for an admin</h1>
        <p className="text-muted-foreground mt-2 text-sm leading-relaxed">
          You&apos;re signed in as <span className="text-foreground font-medium">{user.email}</span>
          , and your account in {organisation.name} needs to be activated before you can use ReAct.
          An admin can do it under <span className="text-foreground font-medium">Users</span>.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <Button onClick={() => void qc.invalidateQueries()} data-testid="check-again">
            <RefreshCw /> Check again
          </Button>
          <Button variant="outline" onClick={() => session.signOut()}>
            <LogOut /> Sign out
          </Button>
        </div>
      </div>
    </main>
  );
}
